module.exports = __webpack_public_path__ + "static/media/glyphicons-halflings-regular.89889688.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap/dist/fonts/glyphicons-halflings-regular.svg
// module id = ./node_modules/bootstrap/dist/fonts/glyphicons-halflings-regular.svg
// module chunks = 0